/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import {
  useInventory,
  useCategories,
  useMerchantConfig,
  usePayoutAccounts,
  useProductDetails,
} from "../api/hooks.js";
import { CreateProductScreen } from "../screens/CreateProductScreen.js";

export function CreateProductRoute({ editId }: { editId?: string }): VNode {
  const { createProduct, updateProduct } = useInventory();
  const { product, resource: productResource } = useProductDetails(editId);
  const { categories, resource: categoriesResource, createCategory } = useCategories();
  const { primaryCurrency, currencies, resource: configResource } = useMerchantConfig();
  const { accounts } = usePayoutAccounts();

  const payoutCurrencies = (accounts ?? [])
    .map((account) => account.currency)
    .filter((currency): currency is string => Boolean(currency));

  return (
    <CreateProductScreen
      editId={editId}
      initialProduct={product}
      productResource={productResource}
      categories={categories ?? []}
      categoriesResource={categoriesResource}
      currency={primaryCurrency}
      currencies={Object.keys(currencies ?? {})}
      configResource={configResource}
      payoutCurrencies={payoutCurrencies}
      onCreateProduct={createProduct}
      onUpdateProduct={updateProduct}
      onCreateCategory={createCategory}
    />
  );
}
